import { render, staticRenderFns } from "./storeCategoryListPage.vue?vue&type=template&id=0efd8c00&"
import script from "./storeCategoryListPage.vue?vue&type=script&lang=ts&"
export * from "./storeCategoryListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports